import { Type } from "@scalar/typebox";
const xScalarClientConfigCookieSchema = Type.Object({
  name: Type.String(),
  value: Type.String(),
  domain: Type.Optional(Type.String()),
  path: Type.Optional(Type.String())
});
const xScalarClientConfigCookiesSchema = Type.Record(Type.String(), xScalarClientConfigCookieSchema);
export {
  xScalarClientConfigCookieSchema,
  xScalarClientConfigCookiesSchema
};
//# sourceMappingURL=x-scalar-client-config-cookies.js.map
